import { render, staticRenderFns } from "./ErpDlsSales.vue?vue&type=template&id=562447d8&scoped=true&"
import script from "./ErpDlsSales.vue?vue&type=script&lang=js&"
export * from "./ErpDlsSales.vue?vue&type=script&lang=js&"
import style0 from "./ErpDlsSales.vue?vue&type=style&index=0&id=562447d8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562447d8",
  null
  
)

export default component.exports